import { initialState } from '../reducers/tools/decisionTree/partialRefund';
import { createSelector } from 'reselect';

const partialRefund = (state) => state.tools.decisionTree.partialRefund || initialState;

const selectLoading = createSelector(partialRefund, (state) => state.loading);
const selectError = createSelector(partialRefund, (state) => state.error);

const selectIsRefunded = createSelector(partialRefund, (state) => state.isRefunded);

const selectRefundAmount = createSelector(partialRefund, (state) => state.refundAmount);

export { selectIsRefunded, selectLoading, selectError, selectRefundAmount };
